import React from "react";

import {
  EMPTY_VALUE,
  formatDueDate,
  formatGivenDate,
} from "./rabiesCertificate.utils";
import { IRabiesVaccination } from "../../../../services/medical-history/medical-history.interface";

type Props = {
  vaccination: IRabiesVaccination;
  // Older doses are superseded by a newer one, so their due date is irrelevant.
  isLatest: boolean;
};

const valueOrEmpty = (value?: string | null) =>
  value && value.trim() !== "" ? value : EMPTY_VALUE;

const RabiesDoseItem = (props: Props) => {
  const { vaccination, isLatest } = props;

  const rows = [
    { label: "Vaccine", value: valueOrEmpty(vaccination.vaccinationName) },
    { label: "Given", value: formatGivenDate(vaccination.administeredAt) },
    { label: "Given By", value: valueOrEmpty(vaccination.administeredBy) },
    ...(isLatest ? [{ label: "Due", value: formatDueDate(vaccination.dueAt) }] : []),
  ];

  return (
    <div className="flex items-start justify-between gap-3" data-testid="rabies-dose-item">
      <div className="flex flex-col gap-1">
        {rows.map((row) => (
          <p key={row.label} className="geograph-regular text-[14px] leading-[20px]">
            <span className="text-light-black">{row.label}: </span>
            <span className="text-gray-1">{row.value}</span>
          </p>
        ))}
      </div>
      <span
        className={`shrink-0 rounded-full px-4 py-1.5 geograph-regular text-[12px] leading-[12px] ${
          isLatest ? "bg-turquoise-1 text-promo-turquoise" : "bg-gray-4 text-light-black"
        }`}
      >
        {isLatest ? "Active" : "Past"}
      </span>
    </div>
  );
};

export default RabiesDoseItem;
